import axios from 'axios';
var flatten = function (list) {
    return list.reduce(function (a, b) { return a.concat(Array.isArray(b) ? flatten(b) : b); }, []);
};
var encodeEntry = function (key, value) { return encodeURIComponent(key) + '=' + encodeURIComponent(value); };
var packEntry = function (accumulator, _a) {
    var key = _a[0], value = _a[1];
    if (typeof value === 'undefined') {
        return accumulator;
    }
    if (Array.isArray(value)) {
        value.forEach(function (value) {
            accumulator.push(encodeEntry(key, Array.isArray(value) ? flatten(value) : value));
        });
    }
    else {
        accumulator.push(encodeEntry(key, value));
    }
    return accumulator;
};
export function buildQueryParams(params) {
    return Object.entries(params)
        .reduce(packEntry, [])
        .join('&');
}
export var axiosInstance = axios.create({
    paramsSerializer: buildQueryParams,
    headers: {
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
    },
});
export function setInstanceBaseURL(baseURL) {
    axiosInstance.defaults.baseURL = baseURL;
}
export function setInstanceToken(token) {
    axiosInstance.defaults.headers.Authorization = "Bearer " + token.access_token;
}
export function resetInstanceToken() {
    delete axiosInstance.defaults.headers.Authorization;
}
//# sourceMappingURL=instance.js.map